(function () {
  if (!window.jQuery || !window.jQuery.ajaxPrefilter) return;

  window.jQuery.ajaxPrefilter(function (options) {
    if (options.async !== false) return;
    var requestUrl;
    try {
      requestUrl = new URL(options.url, window.location.href);
    } catch (error) {
      return;
    }
    // Nova resolves this request through its success/error callbacks already.
    if (requestUrl.origin === window.location.origin && requestUrl.pathname === '/services/javascripts/currencies.js') {
      options.async = true;
    }
  });
})();
